import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useApp } from '../../contexts/AppContext';

const Sidebar = ({ activeSection, setActiveSection }) => {
  const { user } = useAuth();
  const { sidebarOpen, closeSidebar } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const [expandedMenus, setExpandedMenus] = useState({});

  // Actualizar sección activa basada en la ruta actual
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/dashboard')) setActiveSection('dashboard');
    else if (path.includes('/projects')) setActiveSection('projects');
    else if (path.includes('/courses')) setActiveSection('courses');
    else if (path.includes('/students')) setActiveSection('students');
    else if (path.includes('/evaluations')) setActiveSection('evaluations');
    else if (path.includes('/grades')) setActiveSection('grades');
    else if (path.includes('/reports')) setActiveSection('reports');
    else if (path.includes('/admin')) {
      setActiveSection('admin');
      // Expandir automáticamente el menú de administración si estamos en una de sus rutas
      setExpandedMenus(prev => ({ ...prev, admin: true }));
    }
  }, [location.pathname, setActiveSection]);

  const getMenuItems = () => {
    switch (user.role) {
      case 'administrador':
        return [
          {
            id: 'dashboard',
            name: 'Inicio',
            path: '/home',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
            )
          },
          {
            id: 'projects',
            name: 'Proyectos',
            path: '/projects',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            )
          },
          {
            id: 'evaluations',
            name: 'Evaluaciones',
            path: '/evaluations',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            )
          },
          {
            id: 'courses',
            name: 'Cursos',
            path: '/courses',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            )
          },
          {
            id: 'students',
            name: 'Alumnos',
            path: '/students',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            )
          },
          { separator: true },
          {
            id: 'admin',
            name: 'Administración',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            ),
            submenu: [
              {
                id: 'admin-general',
                name: 'General',
                path: '/admin/general',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                )
              },
              {
                id: 'admin-users',
                name: 'Usuarios',
                path: '/admin/users',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-1l-3 3m0 0l-3-3m3 3V5" />
                )
              },
              {
                id: 'admin-roles',
                name: 'Roles y Permisos',
                path: '/admin/roles',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                )
              },
              {
                id: 'admin-objectives',
                name: 'Objetivos de Aprendizaje',
                path: '/admin/objectives',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                )
              },
              {
                id: 'admin-indicators',
                name: 'Indicadores de Evaluación',
                path: '/admin/indicators',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                )
              }
            ]
          }
        ];

      case 'profesor':
        return [
          {
            id: 'dashboard',
            name: 'Inicio',
            path: '/home',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
            )
          },
          {
            id: 'projects',
            name: 'Proyectos',
            path: '/projects',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            )
          },
          {
            id: 'evaluations',
            name: 'Evaluaciones',
            path: '/evaluations',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            )
          }
        ];

      case 'alumno':
        return [
          {
            id: 'dashboard',
            name: 'Inicio',
            path: '/home',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
            )
          },
          {
            id: 'projects',
            name: 'Proyectos',
            path: '/projects',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            )
          },
          {
            id: 'grades',
            name: 'Mis Notas',
            path: '/grades',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            )
          }
        ];

      case 'apoderado':
        return [
          {
            id: 'dashboard',
            name: 'Inicio',
            path: '/home',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
            )
          },
          {
            id: 'projects',
            name: 'Proyectos',
            path: '/projects',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            )
          },
          {
            id: 'grades',
            name: 'Notas',
            path: '/grades',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            )
          }
        ];

      default:
        return [
          {
            id: 'dashboard',
            name: 'Inicio',
            path: '/home',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
            )
          },
          {
            id: 'projects',
            name: 'Proyectos',
            path: '/projects',
            icon: (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            )
          }
        ];
    }
  };

  const toggleMenu = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const handleMenuClick = (item) => {
    // Si el item tiene submenú, expandir/contraer
    if (item.submenu) {
      toggleMenu(item.id);
      return;
    }

    // Si es un item normal, navegar
    setActiveSection(item.id);
    navigate(item.path);
    // Cerrar sidebar en mobile después de hacer click
    if (window.innerWidth < 1024) {
      closeSidebar();
    }
  };

  const sidebarClasses = `
    bg-white shadow-sm border-r border-gray-200 w-64 h-full fixed lg:static
    z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto
    ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
  `;

  return (
    <div className={sidebarClasses}>
      <div className="flex flex-col min-h-full">
        {/* User info section - visible on mobile */}
        <div className="lg:hidden px-4 py-6 border-b border-gray-200">
          <div className="flex items-center">
            <img
              src={user.avatar}
              alt="Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="ml-3">
              <div className="text-sm font-medium text-gray-900">{user.name}</div>
              <div className="text-xs text-gray-500 capitalize">{user.role}</div>
            </div>
          </div>
        </div>

        {/* Navigation menu */}
        <nav className="mt-8 px-4 space-y-2 flex-1">
          {getMenuItems().map((item, index) => {
            if (item.separator) {
              return (
                <div key={`separator-${index}`} className="py-2">
                  <div className="border-t border-gray-200"></div>
                </div>
              );
            }

            const isExpanded = expandedMenus[item.id];
            const hasSubmenu = item.submenu && item.submenu.length > 0;

            return (
              <div key={item.id}>
                {/* Menu principal */}
                <button
                  onClick={() => handleMenuClick(item)}
                  className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
                    activeSection === item.id && !hasSubmenu
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <svg
                    className={`mr-3 h-5 w-5 flex-shrink-0 transition-colors ${
                      activeSection === item.id && !hasSubmenu ? 'text-primary-500' : 'text-gray-400'
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {item.icon}
                  </svg>
                  <span className="flex-1 text-left">{item.name}</span>
                  {hasSubmenu && (
                    <svg
                      className={`h-4 w-4 flex-shrink-0 ml-2 transition-transform duration-200 ${
                        isExpanded ? 'transform rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </button>

                {/* Submenú */}
                {hasSubmenu && isExpanded && (
                  <div className="ml-4 mt-1 space-y-1">
                    {item.submenu.map((subItem) => (
                      <button
                        key={subItem.id}
                        onClick={() => handleMenuClick(subItem)}
                        className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                          location.pathname === subItem.path
                            ? 'bg-primary-50 text-primary-700'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                        }`}
                      >
                        <svg
                          className={`mr-3 h-4 w-4 flex-shrink-0 transition-colors ${
                            location.pathname === subItem.path ? 'text-primary-500' : 'text-gray-400'
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          {subItem.icon}
                        </svg>
                        <span className="text-left">{subItem.name}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer with app info */}
        <div className="px-4 py-4 border-t border-gray-200">
          <div className="text-xs text-gray-500 text-left">
            ABP360 v1.0
            <br />
            Sistema ABP
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;